module.exports = __webpack_public_path__ + "static/media/Forex-market.9cf7b88e.jpg";